export default __webpack_public_path__ + "static/media/feature1.4722c0aa.jpg";